import React from "react";
import {
  Alert,
  List,
  Typography,
  AlertProps,
  AlertPropsVariantOverrides,
} from "@mui/material";
import { INameLengthNotification } from "hooks/translations.interfaces";

interface IProps {
  alertVariant:
    | Extract<keyof AlertPropsVariantOverrides, AlertProps["variant"]>
    | AlertProps["variant"];
  content: INameLengthNotification;
}

export const NameLengthNotification = (props: IProps) => {
  const { content, alertVariant } = props;

  return (
    <Alert
      icon={false}
      variant={alertVariant}
      sx={{ alignItems: "center", gap: 1 }}
    >
      <Typography variant="bodyMedium">{content.text}</Typography>
      <List>
        {content.list.map((listItem, i: number) => {
          return (
            <Typography variant="bodyMedium" key={"list-item-" + i}>
              {listItem.title}
            </Typography>
          );
        })}
      </List>
    </Alert>
  );
};
